module.exports = __webpack_public_path__ + "static/singleContentBlockBack-082cc4e3af92377eb173a03237e0bc5f.png";